<template>
	<div class="plr-16 box-s" :class="{'pb-30': padShow }" id="nodes">

		<!-- 每道题上部的题号和类型 -->
      <div :class="{ 'pt-66': question.stuff_id != 0 }">
				<div class="quest_header flexs h66 bg_f" :class="{ 'ps_top': question.stuff_id != 0, 'plr-16': question.stuff_id != 0 }">
					<div class="c1 fz-16 mb-6"> <span class="fz-28 fw-500">{{present_question_num}}</span> <span class="fw-500">/</span> <span class="c2">{{length}}</span> </div>
          <template v-if="question.stuff_id == 0">
            <div v-if="question_type == 1" class="tag_class ml-5 bg_ff c13">单选题</div>
						<div v-if="question_type == 2" class="tag_class ml-5 bg_dc c12">多选题</div>
						<div v-if="question_type == 3" class="tag_class ml-5 bg_ea c11">判断题</div>
						<div v-if="question_type == 5" class="tag_class ml-5 bg_d8 c0">填空题</div>
						<div v-if="question_type == 4" class="tag_class ml-5 bg_d8 c0">简答题</div>
					</template>
					<div v-else class="tag_class ml-5 bg_bb c16">材料题</div>
				</div>
			</div>
      
			<!-- 材料题总题干 -->
			<div v-if="question.stuff_id != 0 && showStuff" class="pt-155">
				<div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s">
					<div class="over-auto cail" :ref="'DOM' + (present_question_num - 1)" :style="{ 'height': cheight + 'px' }" :class="{ 'trans': showtrans }">
						<div class="fz-14 fw-500 c1" v-if="question.stuff"  v-html="question.stuff"></div>
					</div>
					<div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40" @click="showHe">
						<div class="flexs flex-center l-h-40" v-if="showFlag">
							<div>{{txtflag? '收起': '展开'}}</div>
							<span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
							<span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
						</div>
					</div>
				</div>
			</div>

			<div v-if="question.stuff_id != 0 && !showStuff" class="pt-155">
				<div class="mb-22 box_shaw_6 ps_top top66 plr-16 bg_f box-s zindex1">
					<div class="over-auto cail h98" >
						<div class="fz-14 fw-500 c1" v-if="question.stuff"  v-html="question.stuff"></div>
					</div>
					<div class="flexs flex-center box-s c0 fz-12 fw-500 l-h-40">
						<div class="flexs flex-center l-h-40" v-if="showFlag">
							<div>{{txtflag? '收起': '展开'}}</div>
							<span v-if="!txtflag" class="iconfont icon-arrow-down fz-10 ml-7"></span>
							<span v-else class="iconfont icon-shangjiantou fz-10 ml-7"></span>
						</div>
					</div>
				</div>
			</div>

			<!-- 小题题干 -->
			<div class="fz-14 fw-500 c1 mb-22" v-html="question.question_stem"></div>
      
			<!-- 每道题的主体 -->
			<div class="">
				<!-- 单选题 -->
				<ul class="fz-14 c1" v-if="question_type == 1">
					<li class="flexs mb-22 pd-20-16 bg_f8  b-radius-6 bb-ff box-s flex-jus" :class="{ 'tag_active': (activeRadio === index) && !allIsAnswer, 'checked': allIsAnswer && question.right_answer[0] == Object.keys(item)[0], error_checked: (activeRadio === index) && allIsAnswer && question.right_answer[0] != Object.keys(item)[0] }" v-for="(item, index) in question.prepare_option" :key="index" @click="getRadio(index,Object.keys(item)[0])">
						<div class="flexs flex1">
              <div class="">{{Object.keys(item)[0]}}.</div>
						  <div class="ml-6" v-html="item[Object.keys(item)[0]]"></div>
            </div>
            <div v-if="allIsAnswer" class="ml-10">
              <img v-if="allIsAnswer && question.right_answer[0] == Object.keys(item)[0]" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
              <img v-if="(activeRadio === index) && allIsAnswer && question.right_answer[0] != Object.keys(item)[0]" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
            </div>
					</li>
				</ul>

				<!-- 判断题 -->
				<ul class="fz-14 c1" v-if="question_type == 3">
					<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  checked: allIsAnswer && question.right_answer == 'true', error_checked: isAnswer && activeRadio === 'true' && question.right_answer == 'false', 'tag_active': !allIsAnswer && activeRadio === 'true' }" @click="getRadio('true','true','is')">
						<div class="flexs">
              <div class="">A.</div>
						  <div class="ml-6" >正确</div>
            </div>
            <div v-if="allIsAnswer">
              <img v-if="question.right_answer == 'true'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
              <img v-if="activeRadio === 'true' && question.right_answer == 'false'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
            </div>
					</li>

					<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  checked: allIsAnswer && question.right_answer == 'false', error_checked: allIsAnswer && activeRadio === 'false' && question.right_answer == 'true', 'tag_active': !allIsAnswer && activeRadio === 'false' }" @click="getRadio('false','false', 'is')">
						<div class="flexs">
              <div class="">B.</div>
						  <div class="ml-6" >错误</div>
            </div>
            <div v-if="allIsAnswer">
              <img v-if="question.right_answer == 'false'" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
              <img v-if="activeRadio === 'false' && question.right_answer == 'true'" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
            </div>
					</li>
          
				</ul>
				

				<!-- 多选题 -->
				<div v-if="question_type == 2">
					<ul class="fz-14 c1" :class="{ 'mb-20': !allIsAnswer }">
						<li class="flexs flex-jus bg_f8 mb-22 pd-20-16  b-radius-6 bb-ff box-s" :class="{  'checked': allIsAnswer && question.right_answer.indexOf(Object.keys(item)[0]) != -1, 'error_checked': allIsAnswer && checkedIndex.indexOf(Object.keys(item)[0]) != -1 && question.right_answer.indexOf(Object.keys(item)[0]) == -1,'tag_active': allIsAnswer && question.right_answer.indexOf(Object.keys(item)[0]) != -1 && checkedIndex.indexOf(Object.keys(item)[0]) == -1  || !allIsAnswer && checkedIndex.indexOf(Object.keys(item)[0]) != -1}" v-for="(item, index) in question.prepare_option" :key="index" @click="getChecked(Object.keys(item)[0], index)">
							<div class="flexs flex1">
								<div class="">{{Object.keys(item)[0]}}.</div>
								<div class="ml-6" v-html="item[Object.keys(item)[0]]"></div>
							</div>
							<div class="ml-10">
								<img v-if="allIsAnswer && checkedIndex.indexOf(Object.keys(item)[0]) != -1 && question.right_answer.indexOf(Object.keys(item)[0]) == -1" class="wh_14" src="../../assets/img/icon/error_checked.png" alt="">
								<div v-else-if="allIsAnswer && question.right_answer.indexOf(Object.keys(item)[0]) != -1 && checkedIndex.indexOf(Object.keys(item)[0]) == -1" class="wh_20 b-radius-50 bg_49 l-h-20 text-center fz-12 c7" >漏</div>
								<img v-else-if="allIsAnswer && question.right_answer.indexOf(Object.keys(item)[0]) != -1" class="wh_16_11" src="../../assets/img/icon/checked.png" alt="">
								
							</div>
						</li>
					</ul>

					<div class="submit_quest_btn" @click="checkedSumbit" v-if="!allIsAnswer && !isAnswer">提交</div>
				</div>

				<!-- 填空题/简答题 -->
				<div v-if="question_type == 4 || question_type == 5">
          <div  class="textarea_box mb-12">
						<textarea class="textarea" v-model="textData" :readonly="allIsAnswer" name="" id="" cols="30" rows="10" placeholder="请输入答案"></textarea>
					</div>

					<div class="mb-22">
            <addImg @addImg="addImg" :showDel="!allIsAnswer" @delImg="delImg" :isAnswer="allIsAnswer" :imgList="imgList"/>
					</div>

					<div v-if="!allIsAnswer && !isAnswer" class="submit_quest_btn" @click="textSubmit">提交</div>
				</div>

			</div>
      
			<!-- 答案 -->
      <div v-if="isAnswer || allIsAnswer" class="animal pt-22">
				<div class="mb-22">
					<div class="flexs flex-jus fw-500 c1">
						<div class="flexs">
							<img class="wh_32 mr-10" src="../../assets/img/icon/answer_icon.png" alt="">
							<div class="l-h-16 fz-16  ">题目解析～巩固你的知识吧！</div>
						</div>
						<div class="flexs fz-10 bg_f9 flex-center b-radius-10 wh_74_20" @click="jumpReaction">
							纠错反馈
							<img class="wh_4_6 ml-8" src="../../assets/img/icon/gray_right_arrow_icon.png" alt="">
						</div>
					</div>
				</div>

				<div class=" fz-14 fw-500 c1 mb-10" :class="{ 'flexs': !(question_type == 4 || question_type == 5) }">
					<div class="mr-30 flexs flex-align-start " :class="{'mb-10':question_type == 4 || question_type == 5 }">
						<div class="w75 wrp">
							正确答案：
						</div>
						<div class="c0 flex1" v-html="trueAnswer" v-if="question_type == 4 || question_type == 5"></div> 
						<div class="c0 flex1" v-else>
							{{trueAnswer}}
						</div> 
					</div>

					<div class="flex flex-align-start" v-if="allIsAnswer">
						<div class="w75 wrp">你的答案：</div>
						<div class="c0 flex1" :class="{ 'c9':!answer ||  (answer && answer.is_result == 0) || (answer &&answer.is_result == 2) || submit_answer === '' }">
							{{ !Array.isArray(submit_answer)? (submit_answer === ''? '未答': (submit_answer == 'true'?'正确':submit_answer == 'false'? '错误':submit_answer)): (submit_answer.length == 0? '未答': (submit_answer.length == 1?submit_answer[0]: submit_answer.join(''))) }}
						</div> 
					</div>
				</div>
				<div class="mb-10" v-if="answer && answer.answer_picture && answer.answer_picture.length > 0">
					<addImg :imgList="answer && answer.answer_picture" :showDel="false" :showAdd="false"/>
				</div>

				<div class="fz-14  c1">
					<div class="fw-500 mb-8">题目解析：</div>
					<div v-if="question.analysis" v-html="question.analysis"></div>
				</div>
			</div>
  
      <div>
        
      </div>
    <qusetBottom :cData="cData" :questBtn="questBtn" :present_question_num="present_question_num" @getAnswer="getAnswer" :isAnswer="true" :length="length" :collectFalg="collectFalg" :qusetNum="qusetNum" @getQuest="getQuest" @collect="collect" @quertCard="quertCard" :answerFalg="isAnswer" :colectData="cData"></qusetBottom>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>
<script>
	import loading from "@/components/loading"
	import { randomGetQuestion, randomSubmitAnswer, randomGetAnswer } from '@/api/api.js'
	import {getShowPadding} from "@/utils/common.js";
	import qusetBottom from "@/components/qusetBottom.vue";
	import addImg from "@/components/addImg.vue";
	export default {
		components: {
      qusetBottom,
			addImg,
			loading
		},
		data() {
			return {
				loadFlag: false,
				random_learn_question_id: '',//答题记录id
				padShow: false, //是否展示底部30padding
				length: 0,
				qusetNum: 1, //第几道题
				random_learn: {},
				question: {},
				answer: [],
				isAnswer: false, //是否已答题
				trueAnswer: '', //正确答案
        collectFalg: false, //是否收藏到错题本
        question_type: 0, // 题的类型 1-单选 2-多选 3-判断 4-简答 5-填空 6-材料
        showHeader: false,  //材料题头部动画
				hideHeader: false, //材料题头部动画
				flag: false, //材料题头部动画
				txtflag: false, //材料题头部动画
				timeflag: false, //材料题头部动画
				activeRadio: '', //单选题选中项index
        submit_answer: '',//提交答案
        cData: {
					question_id: '',
					model_type: 3,
					way: 2,
					base_id: '',
					base_user_id: ''
				},//收藏接口需要数据
        imgList: [], //图片列表
				imgIdList: [],//图片id
        textData: '',//简答题和填空题答案
				checkedIndex: [],//多选题选中项
        number: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U","V", "W", "X", "Y", "Z"],//题目前序号

				list: [1,1,1,1], //每一页的题数据
				
				checkBoxTag: [], // 多选题选中项
				radioTag: '', // 单选题选中项
				isTag: '', //判断题选中项
				form: [], //提交数据
        present_question_num: 1,//当前第几道题
        typeNl: 'next',
				previous_random_id: '',
        allIsAnswer: false,
				questBtn: false,
				cheight: '',
				commonHeight: '',
				showFlag: false,
				showtrans: false,
				showStuff: false
				
			};
		},
		created() {
			console.log(999)
			this.length = Number(this.$route.query.length)
			this.id = this.$route.query.recordid? this.$route.query.id:''
			this.random_learn_question_id = this.$route.query.random_learn_question_id
			this.previous_random_id = this.random_learn_question_id
			this.typeNl = this.$route.query.flag? '': (this.$route.query.typeNl?this.$route.query.typeNl: 'next')
      this.initData()
		},
		mounted(){
      this.padShow = getShowPadding()
		},

		methods: {
			init(){
        this.showHeader = false
        this.flag = false
        this.txtflag = false
        this.timeflag = false
        this.imgList = []
        this.imgIdList = []
				this.activeRadio = ''
				this.checkedIndex = []
				this.textData = ''
			},
      async initData(){
				
        this.loadFlag = true
			  const res = await randomGetQuestion({ subject_id: this.$route.query.subject_id, id: this.random_learn_question_id, last_or_next: this.typeNl })
        this.loadFlag = false
				if(res.code == 1000){
					this.init()
					
					this.random_learn_question_id = res.data.random_learn.id //答题记录id
					
					this.random_learn = res.data.random_learn
					this.question = res.data.question
					this.answer = res.data.answer
          this.imgList = this.answer && this.answer.answer_picture?this.answer.answer_picture:[]
					this.present_question_num = this.random_learn.present_question_num //第几道题
					this.qusetNum = this.present_question_num

					this.trueAnswer = Array.isArray(this.question.right_answer)?this.question.right_answer.join('') : (this.question.right_answer == 'true'?'正确': this.question.right_answer == 'false'?'错误':this.question.right_answer) //正确答案

					this.collectFalg = this.random_learn.answer_wrong_id > 0//错题本是否收藏

					this.question_type = this.question.question_type

          if(this.question.stuff_id != 0){
						this.cheight = ''
						this.commonHeight = ''
						this.showHeader = false
						this.txtflag = false
						this.showStuff = true
						console.log(this.$refs, this.commonHeight)
            this.$nextTick(()=>{
							const r = document.documentElement.clientWidth / 375
							this.commonHeight = this.$refs['DOM'+ (this.present_question_num - 1)].offsetHeight * r
							this.cheight = 98 * r
							this.showFlag = this.commonHeight > this.cheight
							console.log(this.commonHeight, this.cheight, this.showFlag,this.$refs['DOM'+ (this.present_question_num - 1)])
							this.showtrans = true
						})
					}

					if(this.random_learn.answer_id){
						this.submit_answer = this.answer.student_answer
						this.allIsAnswer = true
            this.isAnswer = true
						this.cData = { //收藏错题所需数据
							question_id: res.data.question.id,
							model_type: 3,
							way: 3,
							base_user_id: this.random_learn_question_id
						}
						if(this.question_type == 1){
              this.activeRadio = this.number.findIndex(item => this.answer.student_answer[0] == item)
						} else if(this.question_type == 4 || this.question_type == 5) {
              this.textData = this.answer.student_answer[0] //textarea框答案
						} else if(this.question_type == 2) {
              this.checkedIndex = this.answer.student_answer
						} else if(this.question_type == 3) {
              this.activeRadio = this.answer.student_answer
						}
					} else {
						this.cData = { //收藏错题所需数据
							question_id: res.data.question.id,
							model_type: 3,
							way: 2,
							base_id: this.random_learn_question_id
						}
						this.submit_answer = ''
						this.isAnswer = false
						this.allIsAnswer = false
					}
				} else {
					this.$toast(res.msg)
				}
			},

			// 提交问题
			async getSumbit(data){
        const { id, question_id } = this.random_learn
				const form = { id, question_id, answer: JSON.stringify(data)}
				this.loadFlag = true
        const res = await randomSubmitAnswer(form)
				this.loadFlag = false
				if(res.code == 1000){
					this.answer.is_result = res.data.is_result
          this.submit_answer = res.data.submit_answer
					this.isAnswer = true
					this.allIsAnswer = true
					this.cData = { //收藏错题所需数据
						question_id,
						model_type: 3,
						way: 3,
						base_user_id: this.random_learn_question_id
					}
				} else {
            this.$toast(res.msg)
          }
			},

      // 切换单选题 / 判断题
			async getRadio(index, item,type){
				if(this.allIsAnswer) return
        this.activeRadio = index
				let data = type == 'is'?index:[item]
				this.getSumbit(data)
			},

			// 切换多选题
			getChecked(data, index){
				if(this.allIsAnswer) return
				console.log()
        this.checkedIndex.indexOf(data) == -1?this.checkedIndex.push(data):this.checkedIndex.splice(this.checkedIndex.indexOf(data), 1)
			},
      
			// 提交多选题
			async checkedSumbit(){
				if(this.allIsAnswer) return
				this.getSumbit(this.checkedIndex )
			},
      
			// 提交简答题
			async textSubmit(){
				if(this.allIsAnswer) return
				const { id, question_id } = this.random_learn
				const form = { id, question_id, answer: JSON.stringify([this.textData]), picture: this.imgIdList.length == 0? '': this.imgIdList.length ==1? this.imgIdList[0]: this.imgIdList.join(',') }
				this.loadFlag = true
        const res = await randomSubmitAnswer(form)
				this.loadFlag = false
				if(res.code == 1000){
					this.answer.is_result = res.data.is_result
					this.submit_answer = res.data.submit_answer
					this.answer.answer_picture = res.data.answer_picture
					this.imgList = res.data.answer_picture
          this.isAnswer = true
          this.allIsAnswer = true
					this.cData = { //收藏错题所需数据
						question_id,
						model_type: 3,
						way: 3,
						base_user_id: this.random_learn_question_id
					}
				} else {
            this.$toast(res.msg)
          }
			},


			// 上一页，下一页
			getQuest(type){
				document.body.scrollTop = document.documentElement.scrollTop = 0;
				this.showtrans = false
				this.showStuff = false
				this.txtflag = false
				if(type == '1'){
					this.qusetNum = this.qusetNum - 1
					this.typeNl = 'last'
				} else if (type == '2') {
					this.qusetNum =this.qusetNum + 1
					this.typeNl = 'next'
				}
				this.previous_random_id = this.random_learn_question_id
				this.present_question_num = this.qusetNum
        this.initData()
				
			},
      
			// 添加图片
			async addImg(data){
				if(this.allIsAnswer) return
        this.imgList.unshift(data.path)
        this.imgIdList.unshift(data.id)
			},
     
		  // 删除图片
			delImg(index){
				if(this.allIsAnswer) return
        this.imgList.splice(index, 1)
				this.imgIdList.splice(index, 1)
			},

			// 收藏
			collect(collectFalg){
        this.collectFalg = !collectFalg
			},
			// 查看答题卡
			quertCard(){
        this.$router.replace({path: '/randomcard', query:{subject_id: this.$route.query.subject_id, length: this.$route.query.length, random_learn_question_id: this.previous_random_id, typeNl: this.typeNl} })
			},

			// 查看答案
			async getAnswer(){
				if(this.allIsAnswer) return
				this.submit_answer = ''
				this.isAnswer = !this.isAnswer
        
			},
      
			// 材料题展开收起
			showHe(){
				  if(!this.showFlag) return
          if(!this.showHeader){
            const h = document.documentElement.clientHeight * (document.documentElement.clientWidth / 375) * 0.55
						this.cheight = this.commonHeight > h ? h : this.commonHeight
					} else {
						this.cheight = 98 * (document.documentElement.clientWidth / 375)
						this.$nextTick(() => {
							this.$refs['DOM'+ (this.qusetNum - 1)][0]?this.$refs['DOM'+ (this.qusetNum - 1)][0].scrollTo(0,0):this.$refs['DOM'+ (this.qusetNum - 1)].scrollTo(0,0);
						})
					}
					
          this.showHeader = !this.showHeader
					this.txtflag = this.showHeader
				
        
			},

			// 跳转错题反馈
			jumpReaction(){
        this.$router.push({ path: '/reaction', query: { question_id: this.random_learn_question_id, length: this.$route.query.length, random_learn_question_id: this.previous_random_id, typeNl: this.typeNl, type: 'random',subject_id: this.$route.query.subject_id } })
			}

		}
	};
</script>
<style lang="less" scoped>
ul li:last-child {
	margin-bottom: 0;
}

.animal {
	animation: show 1s;
	animation-fill-mode:forwards;
}

@keyframes show {
	0% {
		display: none;
	}
	100% {
		display: block;
	}
}

.h100px {
  height: 98px;
	transition: all 1s;
}
.heightamimal {
	overflow: auto;
	height: 50vh;
}
.heightamimal::-webkit-scrollbar {
  display: none;
}

</style>
